<template>
  <div class="cpt-skeleton-left-sidebar-wrapper skeleton">
    <div v-for="i in 2" :key="`tool-item-${i}`" class="tools-wrapper skeleton-wrapper">
      <div class="avatar-skeleton" :style="{ animationDelay: `${i * 0.74}s` }" />
    </div>
    <div class="split-line"></div>
    <div v-for="i in 2" :key="`room-item-${i}`" class="rooms-wrapper skeleton-wrapper">
      <div class="avatar-skeleton" :style="{ animationDelay: `${i * 0.74}s` }" />
    </div>
    <div class="createroom">
      <div
        class="shortcut-block"
        @click="$emit('showCreateRoomDialog')"
        v-tooltip="{'text': '创建房间', placement: 'right'}"
      >
        <i class="iconfont icon-add-bold create-room"></i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    size: {
      type: String,
      default: 'normal'
    }
  },
};
</script>
<style lang="scss">
.cpt-skeleton-left-sidebar-wrapper {
  @import "_css/skeleton.scss";
  margin-top: 8px;
  &.skelton {
    overflow-y: hidden;
  }
  .skeleton-wrapper {
    .avatar-skeleton {
      width: 42px;
      height: 42px;
      margin-bottom: 12px;
      border-radius: 10px;
      @include skeleton-background();
      @include skeleton-animation();
    }
    &.tools-wrapper {
      .avatar-skeleton {
        border-radius: 50%;
      }
    }
  }
  .split-line {
    width: 42px;
    height: 1px;
    margin-bottom: 12px;
    background: $d-ln-4;
  }
  .createroom {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 42px;
    height: 42px;
    border-radius: 10px;
    background: rgba(#FFF, .08);
    cursor: pointer;
    i.create-room {
      font-size: 20px;
      color: rgba(#FFF ,.5);
    }
  }
}
  
</style>